import { defineStore } from "pinia";
import { ref } from "vue";

export const useAppStatusStore = defineStore("appStatusStore", () => {
  const serverMaintenance = ref(false);

  function setServerMaintenance(value: boolean) {
    serverMaintenance.value = value;
  }
  return {
    serverMaintenance,
    setServerMaintenance, 
  };
});